class Dismissible {
  constructor() {
    const alerts = document.querySelectorAll('.alert-dismissible');
    // show/hide alerts based on session or local storage
    alerts.forEach((item) => {
      this.makeAlertDismissible(item);
    });

    const consent = document.querySelector('#cookie-consent');
    // show/hide consent based on session or local storage
    if (consent !== null)
      this.makeConsentDismissible(consent);

    const modals = document.querySelectorAll('.modal-dismissible');
    // show/hide modals based on session or local storage
    modals.forEach((item) => {
      this.makeModalDismissible(item);
    });
  }

  makeDismissible(item, type, dismissalHoursFunction, showAction, hideAction, registerCloseAction) {
    const elementId = type + item.id;
    const dismissalHours = dismissalHoursFunction(item);
    let dismissed = false;
    // if > 0, use local storage w/ expiration
    if (dismissalHours > 0) {
      const storedTime = parseInt(window.localStorage[elementId]) || 0;
      if (storedTime) {
        // check dismissal expiration
        if (storedTime > (new Date()).getTime()) {
          dismissed = true;
        } else {
          // remove expired dismissal
          window.localStorage.removeItem(elementId);
        }
      }
    }
    // if dismissalHours == 0 use session storage
    else {
      dismissed = window.sessionStorage[elementId] == 'true';
    }

    if (dismissed) {
      hideAction(item);
      item.setAttribute('data-dismissible', 'dismissed');
    } else {
      showAction(item);
    }

    registerCloseAction(item, function () {
      if (dismissalHours > 0) {
        const expires = new Date();
        expires.setHours(expires.getHours() + dismissalHours);
        window.localStorage[elementId] = expires.getTime();
      } else {
        window.sessionStorage[elementId] = 'true';
      }
    });
  }

  makeAlertDismissible(item) {
    this.makeDismissible(item, 'alert', (item) => parseInt(item.dataset.dismissalHours) || 0, (item) => $(item).addClass('show'), (item) => {}, (item, onClose) => $(item).on('closed.bs.alert', onClose));
  }

  makeConsentDismissible(item) 
  {
    this.makeDismissible(item, 'consent', (item) => 8760, (item) => $(item).show(), (item) => $(item).hide(), (item, onClose) => $(item).find('.accept-button').click(function() { $(item).hide(); onClose(); }));
  }

  makeModalDismissible(item) {
    this.makeDismissible(item, 'modal', (item) => parseInt(item.dataset.dismissalHours) || 0, (item) => $(item).modal('show'), (item) => { }, (item, onClose) => $(item).on('hidden.bs.modal', onClose));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Dismissible();
})
